import { useEffect, useState } from "react";
import CustomScroll from '@src/component/customScroll'
import sccg from '@src/assets/image/rzIndex/success.png'
import {getPhoneNumber} from '@src/service/commonService'
import { Toast } from 'antd-mobile'
import './index.scss'
import { gotor } from "@src/route";
export default function() {
  const [phone, setPhone] = useState<string>()
  useEffect(()=>{
    getPhoneNumber().then(res=>{
      setPhone(res.value)
    }).catch((err)=>{
      Toast.show(err?.errmsg || '电话查询失败')
    })
  })
  return <div className="page bottomFit submitok">
    <CustomScroll>
      <div className='box'>
        <div className='dyg'>
          <img src={sccg} alt=""></img>
          <div className='tjcg'>提交成功，请等待审批！</div>
        </div>
        <div className="ts">
          <div className='wxts dotted-line'>温馨提示</div>
          <div className='xwz'>1、请留意审核反馈意见，若要求增加担保人，请告知您的担保人准备以下资料：</div>
          <div className='xwz en'>①担保人身份证正面、反面照片（要求20-55周岁）</div>
          <div className='xwz en'>②中国人民银行电子征信报告</div>
          <div className='xwz'>2、若有疑问，请联系分期客服中心电话：<span onClick={()=>{location.href=`tel:${phone as string}`}}>{phone}</span></div>
        </div>
      </div>
    </CustomScroll>
    <div className="button-them" onClick={()=>{
      gotor('/order')
    }}>查看订单</div>
  </div>
}